import { Box, Drawer, IconButton } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Hidden from "../../../components/Hidden";
import { useTheme } from "@emotion/react";

const SeeApp = ({ openTesteApp, toogleTesteApp, identificadorDelivery }) => {
  const theme = useTheme();
  return (
    <>
      {identificadorDelivery ? (
        <Hidden mdDown implementation="css">
          <Drawer
            open={openTesteApp}
            variant="persistent"
            classes={{
              paper: {
                transition: theme.transitions.create("width", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.enteringScreen,
                }),
                background: "white",
              },
            }}
            anchor="right"
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              pr={3}
              pt={16}
            >
              <IconButton color="inherit" onClick={toogleTesteApp} size="small">
                <ChevronRightIcon />
              </IconButton>

              <Box>
                <Box
                  p={1}
                  fontSize="h5.fontSize"
                  align="center"
                  display="block"
                >
                  {" "}
                  Confere o seu app 👇
                </Box>
                <Box boxShadow={2}>
                  <iframe
                    style={{ minWidth: "20vw", height: "75vh", border: "none" }}
                    src={
                      (process.env.NODE_ENV === "production"
                        ? "https://"
                        : "http://") +
                      identificadorDelivery +
                      (process.env.NODE_ENV === "production"
                        ? ".qrpedir.com"
                        : ".localhost:3001")
                    }
                    title="Preview app qrpedir"
                    sanddbox="true"
                  ></iframe>
                </Box>
              </Box>
            </Box>
          </Drawer>
        </Hidden>
      ) : null}
    </>
  );
};

export default SeeApp;
